export default {
    methods: {
        print: function (printId) {
            var contents = document.getElementById(printId).innerHTML;
            //Get the HTML of whole page
            var defaultPage = document.body.innerHTML;
            //Reset the page's HTML with div HTML only
            document.body.innerHTML = "<html><head><title></title></head><body>" + contents + "</body>";
            //Print Page
            setTimeout(() => {
                window.print();
                //Restore original HTML
                document.body.innerHTML = defaultPage;
                window.location.reload();
            }, 1500);
        },
        printWeb: function (printId) {
            const prtHtml = document.getElementById(printId).innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
            }

            // Open the print window
            const printDocument = window.open('', '_blank');
            printDocument.document.write(`<!DOCTYPE html>
            <html>
                <head>
                    <title>
                        DigiCollect CRM
                    </title>
                    ${stylesHtml}
                    <style>
                        body{
                            overflow: auto !important;
                            background: #bed1f8 !important;
                        }
                    </style>
                </head>
                <body>
                    ${prtHtml}
                </body>
            </html>`);
            setTimeout(() => {
                printDocument.document.close();
                printDocument.focus();
                printDocument.print();
            }, 2000);
            setTimeout(() => {
                printDocument.close();
            }, 2000);
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/print.js